import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api"



import Header from "./content/header"

class EditCategoriaAdmin extends Component {

state= {
  categoria:[],
  idcategoria:null,
  nome:null,
  error:null,
  success:null
}

  async componentDidMount(){
    this.loadcategoria();
  

  }


  async loadcategoria () {

    const response = await api.post("/categorias/id", { idcategoria:this.props.match.params.idcategoria });
    this.setState({
      categoria:response.data,
      idcategoria:this.props.match.params.idcategoria
    })

  }






  editcat = async e => {
    e.preventDefault();
    const { nome,idcategoria } = this.state;
      if (!nome || !idcategoria) {
          this.setState({ error: "Preencha o nome antes de editar!",
        success:null });
          
      } else {
      const { nome,idcategoria } = this.state;
      const response = await api.post("/admin/categoria/edit", { idcategoria, nome });

        if(response.data.id){
          this.setState({ success: "Categoria Editada!" , error:null,
        nome:null });
          this.loadcategoria();
        }

      }
  }


  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-6 p-4">     

        <h4>Editar Categoria</h4>     
        <form onSubmit={this.editcat}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome Anterior</label>
                    <input type="text" class="form-control" value={this.state.categoria.nome} disabled />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Novo Nome</label>
                    <input type="text" class="form-control" value={this.state.nome} onChange={e => this.setState({ nome: e.target.value })}  placeholder="Novo Nome" />
                </div>
                <div class="form-group">
                <button class="btn btn-primary mb-2">Mudar Nome</button>

                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(EditCategoriaAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/editcategoria.js